/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';

// Import New Window Script
import './plugins/jquery.newWin';

// Import Touch Support via jQuery Mobile
import './plugins/jquery.mobile.custom.js';

// Plyr
import Plyr from 'plyr';

// Import Scroll Overflow / Patched for fullPage.js
import 'fullpage.js/vendors/scrolloverflow.js';

// fullPage.js / fadingEffect
// import './plugins/fullpage.fadingEffect.min.js'

// Importing fullpage.js
// import fullpage from 'fullpage.js';
import fullpage from 'fullpage.js/dist/fullpage.extensions.min';

// object-cover polyfill
import 'object-fit-polyfill/dist/object-fit-polyfill';

// When using fullPage extensions replace the previous import
// of fullpage.js for this file
//import fullpage from 'fullpage.js/dist/fullpage.extensions.min';
// cheat sheet https://jsfiddle.net/0hLzxrea/31/

const validAnchors = ['intro1', 'intro2', 'intro3', 'intro4', 'intro5', 'intro6', 'intro7', 'intro8', 'intro9', 'intro10', 'intro11', 'intro12', 'intro13',
'erste-bank-glaubandich', 'erste-bank-tagtrauemer',
'more1_1', 'more1_2', 'more1_3',
'video_2_1', 'video_2_2', 'video_2_3', 'video_2_4', 'video_2_5',
'vdb_1', 'vdb_2', 'vdb_3', 'vdb_4', 'vdb_5', 'vdb_6',
'fin'];

let pageVisible = false;

function showPage(){
  if (pageVisible) {
    return;
  }

  pageVisible = true;

  $('body').removeClass('showOverlay');

  setTimeout(showScrollbars, 1000);
  setTimeout(enableScroll, 1500);
}

function isTouchDevice() {
  return (('ontouchstart' in window)
    || (navigator.MaxTouchPoints > 0)
    || (navigator.msMaxTouchPoints > 0));
}

function showScrollbars() {
  $('body').removeClass('noScrollbars');
}

function disableScroll() {
  if (!('fullpage_api' in window)) {
    return;
  }

  if (isTouchDevice()) { 
    window.fullpage_api.setAllowScrolling(false);
    window.fullpage_api.setKeyboardScrolling(false);
  }

  document.documentElement.style = 'overflow: hidden; height: 100%;';
  document.body.style = 'overflow: hidden; height: 100%;';
}

function enableScroll() {
  if (!('fullpage_api' in window)) {
    return;
  }

  if (isTouchDevice()) { 
    document.documentElement.style = 'overflow: visible; height: initial;';
    document.body.style = 'overflow: visible; height: initial;';
  }

  window.fullpage_api.setAllowScrolling(true);
  window.fullpage_api.setKeyboardScrolling(true);
}


$('body').addClass('noScrollbars');

// Touch Class
if (!("ontouchstart" in document.documentElement)) {
  document.documentElement.className += " no-touch";
}

var fromIndex = 1;

// Initializing it
var fullPageInstance = new fullpage('#tb__fullpage', {
    //options here
    licenseKey: 'F9F65709-ACE64E39-AD5DABE8-37D9CC0F',
    // fadingEffect: true,
    // fadingEffectKey: 'dG9ycmVzYmFyeWxsaS5jb21fekUyWm1Ga2FXNW5SV1ptWldOMHhDSw==',
    anchors: validAnchors,
    scrollOverflow: true,
    scrollOverflowOptions:{ click: false, preventDefaultException: { tagName:/.*/ }, },
    navigation: true,
    css3: true,
    scrollingSpeed: 400,
    sectionsColor: ['#d6cbd2', '#e2d2dd', '#e2d2dd', '#e2d2dd', '#e2d2dd', '#e2d2dd', '#e2d2dd', '#e2d2dd', '#e2d2dd', '#e2d2dd', '#e2d2dd', '#e2d2dd', '#e2d2dd',
    '#000', '#000',
    '#000', '#000', '#000',
    '#000', '#000', '#000', '#000', '#000',
    '#000', '#000', '#e2d2dd', '#e2d2dd', '#e2d2dd', '#e2d2dd', '#000',
    '#e2d2dd'],
    easing: 'easeInOutCubic',
    easingcss3: 'ease',
    bigSectionsDestination: 'top',
    paddingTop: '0',
    paddingBottom: '0',
    onLeave: function(origin, destination, direction){
      fromIndex = origin;
        
      // if(!origin){
      // fullpage_api.setScrollingSpeed(0);
      // $('.fp-section').find('.fp-slidesContainer').hide();
     // }
      
      console.log('leave');
      var source = origin.index + 1;
      var target = destination.index + 1;
      
      var videoTarget = $('.fp-section:nth-child(' + (origin.index + 1) + ')').attr('data-video');
      if (videoTarget) {
        videoTarget--;
        players[videoTarget].pause();
      };
    },
    afterLoad: function(origin, destination, direction){
      var source = origin.index + 1;
      var target = destination.index + 1;
      var videoTarget = $('.fp-section:nth-child(' + (destination.index + 1) + ')').attr('data-video');
      if (videoTarget) {
        videoTarget--;
        players[videoTarget].play();
      };
    },
});

/*
$('.plyr').on('play', function(event) {
  $(this).addClass('plyr--init-play');
});
*/

// disable fullpage fading
// fullpage_api.fadingEffect.turnOff();

if (validAnchors.indexOf(window.location.hash.replace('#', '')) > -1) {
  showPage();
}

/*
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  lazyLoadMuellersbureau.update();
  lazyLoadProjekte.update();
});
*/

// Plyr
const players = Array.from(document.querySelectorAll('.tb__plyr')).map(p => new Plyr(p, {
    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume'],
    keyboard: { focused: false, global: false },
    // blankVideo: 'https://cdn.plyr.io/static/blank.mp4',
    // poster: 'http://pitch.torresbarylli.com/app/uploads/2020/12/1_ariel_720p_preview.jpg',
  }
));

// handling of finished video
players.forEach(function (instance) {
  instance.on('ended', function () {
    fullpage_api.moveSectionDown();
  });
});

$(document).ready(() => {  
  // Polyfill
  // objectFitPolyfill();
  
  // Link Handling
  $('a[href$=".pdf"]').click(function openPDF() { open(this.href); return false; });
  $('a.downloadlink').click(function openDownload() { open(this.href); return false; });
  $('a[href^="http"]:not(.video)').newWin();
  
  var tbResizeId;
  
  // 100vh on iOS
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  $('.plyr__video-wrapper').css({ height: vh * 100 });
  fullpage_api.reBuild();

  $(window).resize(function() {
    clearTimeout(tbResizeId);
    tbResizeId = setTimeout(doneResizing, 500);
  });
  
  function doneResizing(){
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    $('.plyr__video-wrapper').css({ height: vh * 100 });
    fullpage_api.reBuild();
  }
});
